window.theme = window.theme || {};
var Util = UIkit.util;

theme.UserAccount = (function () {

    var selectors = {
        ordersList: '#orders-table',
        backToList: '.back-to-orders',
        viewOrderDetails: '.view-order-details',
    };

    function initEventListeners() {

        var l = document.querySelector(selectors.ordersList);

        Util.on(selectors.viewOrderDetails, 'click', function (evt){
            // Hide list
            Util.addClass(l, "uk-hidden");
        });

        Util.on(selectors.backToList, 'click', function (evt){
            Util.removeClass(l, "uk-hidden")
        });
    }

    return {
        init: function () {
            initEventListeners();
        }
    };
})();

document.addEventListener('DOMContentLoaded', function () {
    theme.UserAccount.init();
})